<script lang="ts">
	import type { SelectedChatUser } from "../state/chat_state";

	import RawModal from "$lib/utils/components/RawModal.svelte";
	import Badge from "$lib/components/ui/badge/badge.svelte";
	import FaIcon from "$lib/utils/components/FaIcon.svelte";

	import { chat_state } from "../state/chat_state";

	let { own_user }: { own_user: SelectedChatUser } = $props();

	let is_modal_open = $state(false);
</script>

{#if own_user}
	{#if is_modal_open}
		<RawModal card_classes="px-px" bind:open={is_modal_open}>
			{#await import("./MessagesMenu.svelte") then MessagesMenu}
				<MessagesMenu.default
					{own_user}
					close_fn={() => (is_modal_open = false)}
				/>
			{/await}
		</RawModal>
	{/if}

	<button
		onclick={() => (is_modal_open = !is_modal_open)}
		class="relative flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg
{is_modal_open ? 'bg-card text-foreground duration-300 ease-linear' : ''}
hover:bg-card hover:text-foreground hover:duration-300 hover:ease-linear"
	>
		{#if chat_state.unread_messages.count}
			<Badge
				class="absolute top-1 right-1 size-4 text-[10px] rounded-full px-2 "
				variant="destructive"
			>
				{chat_state.unread_messages.count}
			</Badge>
		{/if}

		<FaIcon name="faComments" />
	</button>
{/if}
